import { createContext, useContext } from "react";
import {subMonths} from "date-fns";

type DashboardFilters = {
  fromTimestamp?: number;
  toTimestamp?: number;
  variantId?: string;
  productId?: string;
  resolution?: string;
  reason?: string;
  sourceChannel?: string;
};

export const INITIAL_DASHBOARD_FILTERS: DashboardFilters = {
  fromTimestamp: subMonths(Date.now(), 1).getTime(),
  toTimestamp: Date.now(),
  variantId: undefined,
  productId: undefined,
  resolution: undefined,
  reason: undefined,
};

const DashboardFiltersContext = createContext<DashboardFilters>(
  INITIAL_DASHBOARD_FILTERS,
);

export function useDashboardFilters() {
  return useContext(DashboardFiltersContext);
}

type DashboardFiltersProviderProps = {
  children: React.ReactNode;
  value: DashboardFilters;
};

export function DashboardFiltersProvider({
  children,
  value,
}: DashboardFiltersProviderProps) {
  return (
    <DashboardFiltersContext.Provider value={value}>
      {children}
    </DashboardFiltersContext.Provider>
  );
}
